export default __webpack_public_path__ + "static/5-b18efad8cfc81feaaad808af5a027f2d.jpeg";